import React, { useState } from 'react';
import { sendClientLink, updateAnalytics } from '@services';
import { useMutation } from 'react-query';
import { NavButton } from './styles';
import { ANALYTICS_EVENTS, TOAST_TYPES } from '@constants';
import { toastNotification } from '@utils/toast';
import { getErrorMessage } from '@utils/errorHandling';
import { usePresentation } from '@context/presentation';
import { createAnalyticsEventBody } from '@utils/analytics';

export const SendLinkButton = () => {
    const { success, error } = TOAST_TYPES;
    const [sendingLink, setSendingLink] = useState(false);
    const { presentationId } = usePresentation();

    const mutation = useMutation(sendClientLink, {
        onSuccess: async () => {
            setSendingLink(false);
            const { inviteSent } = ANALYTICS_EVENTS;

            toastNotification(success, 'Link emailed to client!');
            await updateAnalytics(createAnalyticsEventBody(presentationId, inviteSent));
        },
        onError: err => {
            setSendingLink(false);
            toastNotification(error, `Error sending link to client: ${getErrorMessage(err)}`);
        }
    });

    function sendLink() {
        setSendingLink(true);

        mutation.mutate();
    }

    return (
        <>
            <NavButton disabled={sendingLink} onClick={sendLink}>
                {sendingLink ? 'Sending link...' : 'Send link'}
            </NavButton>
        </>
    );
};

export default SendLinkButton;